export enum HttpStatusCodes {
	HTTP_STATUS_CONTINUE = 100,
	HTTP_STATUS_SWITCH_PROTOCOLS,

	HTTP_STATUS_OK = 200,
	HTTP_STATUS_CREATED,
	HTTP_STATUS_ACCEPTED,
	HTTP_STATUS_PARTIAL,
	HTTP_STATUS_NO_CONTENT,
	HTTP_STATUS_RESET_CONTENT,
	HTTP_STATUS_PARTIAL_CONTENT,
	HTTP_STATUS_WEBDAV_MULTI_STATUS,

	HTTP_STATUS_AMBIGUOUS = 300,
	HTTP_STATUS_MOVED,
	HTTP_STATUS_REDIRECT,
	HTTP_STATUS_REDIRECT_METHOD,
	HTTP_STATUS_NOT_MODIFIED,
	HTTP_STATUS_USE_PROXY,
	HTTP_STATUS_REDIRECT_KEEP_VERB = 307,
	HTTP_STATUS_PERMANENT_REDIRECT,

	HTTP_STATUS_BAD_REQUEST = 400,
	HTTP_STATUS_DENIED,
	HTTP_STATUS_PAYMENT_REQ,
	HTTP_STATUS_FORBIDDEN,
	HTTP_STATUS_NOT_FOUND,
	HTTP_STATUS_BAD_METHOD,
	HTTP_STATUS_NONE_ACCEPTABLE,
	HTTP_STATUS_PROXY_AUTH_REQ,
	HTTP_STATUS_REQUEST_TIMEOUT,
	HTTP_STATUS_CONFLICT,
	HTTP_STATUS_GONE,
	HTTP_STATUS_LENGTH_REQUIRED,
	HTTP_STATUS_PRECOND_FAILED,
	HTTP_STATUS_REQUEST_TOO_LARGE,
	HTTP_STATUS_URI_TOO_LONG,
	HTTP_STATUS_UNSUPPORTED_MEDIA,
	HTTP_STATUS_RETRY_WITH = 449,

	HTTP_STATUS_SERVER_ERROR = 500,
	HTTP_STATUS_NOT_SUPPORTED,
	HTTP_STATUS_BAD_GATEWAY,
	HTTP_STATUS_SERVICE_UNAVAIL,
	HTTP_STATUS_GATEWAY_TIMEOUT,
	HTTP_STATUS_VERSION_NOT_SUP,
}

export type HttpMethods = 'GET' | 'PUT' | 'POST' | 'PATCH' | 'DELETE' | 'HEAD';
